import type { Faq, PainPoint } from '../types/content';
export const painPoints: PainPoint[] = [{
  title: 'No saber por dónde empezar',
  text: 'Cada mañana te preguntás qué cuidados organizar primero.'
}, {
  title: 'Miedo a equivocarte',
  text: 'Te preocupa realizar incorrectamente una tarea cotidiana.'
}, {
  title: 'Desorganización diaria',
  text: 'Entre tantas responsabilidades, se te hace difícil mantener una rutina.'
}, {
  title: 'Información dispersa',
  text: 'Perdés tiempo buscando indicaciones en diferentes lugares.'
}, {
  title: 'Agotamiento y falta de apoyo',
  text: 'Terminás ocupándote de casi todo sin saber cómo distribuir las responsabilidades.'
}];
export const faqs: Faq[] = [{
  question: '¿Necesito tener experiencia cuidando personas en cama?',
  answer: 'No. El kit está pensado para familiares sin formación sanitaria. Incluye rutinas preparadas y guías visuales para consultar.'
}, {
  question: '¿Tengo que crear mis propias rutinas o planillas?',
  answer: 'No. Recibís un plan de 30 días, listas, actividades y otros recursos previamente organizados.'
}, {
  question: '¿Sirve si mi familiar necesita cuidados especiales?',
  answer: 'Incluye orientaciones generales. Los cuidados específicos deben adaptarse a las indicaciones de su equipo de salud.'
}, {
  question: '¿El kit reemplaza la atención médica o de enfermería?',
  answer: 'No. Es un material de apoyo y no reemplaza las indicaciones profesionales.'
}, {
  question: '¿Cómo recibo los materiales?',
  answer: 'Después de comprar, recibís por email el acceso inmediato a todo el contenido en formato PDF.'
}];
export const costs = ['Cada día volvés a pensar por dónde empezar.', 'Te preocupa equivocarte en alguna tarea cotidiana.', 'Se te acumulan responsabilidades sin una rutina preparada.', 'Seguís buscando información en distintos lugares.', 'Terminás agotada intentando resolver todo sin suficiente organización.'];
export const purchases = [['Alicia B.', 'Buenos Aires'], ['Verónica P.', 'Córdoba'], ['Claudia F.', 'Rosario'], ['Daniela L.', 'Mendoza'], ['Marcela V.', 'La Plata'], ['Patricia S.', 'Neuquén'], ['Elena R.', 'Mar del Plata']];
